import React from "react"
import styles from './PlaylistHeader.module.css'

export const PlaylistHeader = ({ value, src }) => {
    return <div className={styles.playlist__header}>
        <img
            className={styles.playlist__image}
            src={src ? src : ''}
        />
        <h1
            className={styles.playlist__artist}
        >{value}</h1>
    </div>
}